import uniAdminApi from "./api";

const clubScopeService = {
  getScopes: async (adminUserId) => {
    const res = await uniAdminApi.get(`/university-admin/club-scopes/${adminUserId}`);
    return res.data;
  },

  grantScope: async ({ adminUserId, clubId }) => {
    const res = await uniAdminApi.post("/university-admin/club-scopes", { adminUserId, clubId });
    return res.data;
  },

  revokeScope: async ({ adminUserId, clubId }) => {
    const res = await uniAdminApi.delete("/university-admin/club-scopes", {
      data: { adminUserId, clubId },
    });
    return res.data;
  },
};

export default clubScopeService;
